(() => {
  const protectedSelector =
    'img, picture, a[href*="/cdn/shop/"]';

  const style = document.createElement('style');

  style.textContent = `
    img,
    picture,
    picture img,
    a[href*="/cdn/shop/"] {
      -webkit-touch-callout: none !important;
      -webkit-user-select: none;
      user-select: none;
      -webkit-user-drag: none;
    }
  `;

  document.head.appendChild(style);

  const isProtected = (target) =>
    target instanceof Element &&
    Boolean(target.closest(protectedSelector));

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (isProtected(event.target)) {
        event.preventDefault();
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (isProtected(event.target)) {
        event.preventDefault();
      }
    },
    { capture: true }
  );
})();